import { render, staticRenderFns } from "./veStuLiteraryActiveShow.vue?vue&type=template&id=1bef4d32&scoped=true"
import script from "./veStuLiteraryActiveShow.vue?vue&type=script&lang=js"
export * from "./veStuLiteraryActiveShow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bef4d32",
  null
  
)

export default component.exports